export default __webpack_public_path__ + "static/media/close.71497c14.svg";